import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL } from "@/data/navigationData";

export function Footer() {
  return (
    <footer className="bg-[#0E0A06] text-white/60 pt-16 pb-8">
      <div className="container-hh">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img src={LOGO_URL} alt="Happyhouse conciergerie" className="h-12 rounded-xl border border-[#C9922A]/20 p-1" />
            </Link>
            <p className="text-sm leading-relaxed text-white/40">
              Conciergerie et sous-location professionnelle à Limoges et Évaux-les-Bains.
            </p>
          </div>

          <div>
            <h4 className="text-[#C9922A] font-semibold text-xs uppercase tracking-[0.15em] mb-4">Propriétaires</h4>
            <ul className="space-y-2.5">
              <li><Link to="/sous-location" className="text-sm hover:text-[#C9922A] transition-colors">Offre Sérénité</Link></li>
              <li><Link to="/conciergerie-privee" className="text-sm hover:text-[#C9922A] transition-colors">Offre Partenariat</Link></li>
              <li><Link to="/simulateur" className="text-sm hover:text-[#C9922A] transition-colors">Simulateur</Link></li>
              <li><Link to="/expertise" className="text-sm hover:text-[#C9922A] transition-colors">Notre expertise</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#C9922A] font-semibold text-xs uppercase tracking-[0.15em] mb-4">Voyageurs</h4>
            <ul className="space-y-2.5">
              <li><Link to="/voyageurs" className="text-sm hover:text-[#C9922A] transition-colors">Nos logements</Link></li>
              <li><Link to="/blog" className="text-sm hover:text-[#C9922A] transition-colors">Blog & Guides</Link></li>
              <li><Link to="/faq" className="text-sm hover:text-[#C9922A] transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-sm hover:text-[#C9922A] transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[#C9922A] font-semibold text-xs uppercase tracking-[0.15em] mb-4">Contact</h4>
            <div className="space-y-3 text-sm">
              <a href="tel:+33767484313" className="flex items-center gap-2.5 hover:text-[#C9922A] transition-colors">
                <Phone className="w-3.5 h-3.5 text-[#C9922A]/60" /> +33 7 67 48 43 13
              </a>
              <a href="mailto:contact@happyhouse-conciergerie.fr" className="flex items-center gap-2.5 hover:text-[#C9922A] transition-colors">
                <Mail className="w-3.5 h-3.5 text-[#C9922A]/60" /> contact@happyhouse-conciergerie.fr
              </a>
              <div className="flex items-center gap-2.5">
                <MapPin className="w-3.5 h-3.5 text-[#C9922A]/60 flex-shrink-0" /> Limoges & Évaux-les-Bains
              </div>
            </div>
            <div className="flex items-center gap-3 mt-5">
            </div>
          </div>
        </div>

        <div className="border-t border-white/[0.06] pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/30">
            © {new Date().getFullYear()} Happyhouse conciergerie. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6 text-xs text-white/30">
            <Link to="/mentions-legales" className="hover:text-[#C9922A] transition-colors">Mentions légales</Link>
            <Link to="/politique-confidentialite" className="hover:text-[#C9922A] transition-colors">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
